export default {
	// 轮播
	getBanners: ()=> {
		return [
			{
				// text: '旗舰航拍机', slogan: '5619615651651', headline: '影像至上', link: '',
				img: 'http://igstech.com.cn/resources/shouye/lunbotu/lunbotu1.jpg'
			},
			{
				// text: '新款-迷你无人机', slogan: 'DJI MINI 3 PRO', headline: '小有成就', link: '',
				img: 'http://igstech.com.cn/resources/shouye/lunbotu/lunbotu2.jpg'
			},
			{
				// text: 'T40 农业无人机', slogan: '', headline: '集结强大', link: '',
				img: 'http://igstech.com.cn/resources/shouye/lunbotu/lunbotu3.jpg'
			},
			{
				// text: 'T40 农业无人机1', slogan: '', headline: '集结强大', link: '',
				img: 'http://igstech.com.cn/resources/shouye/lunbotu/IGS-60lunbotu.1.jpg'
			},
		]
	},
	// 四方格
	getPatterns: ()=> {
		return [
      {
        text: '',
        slogan: 'IGS 70',
        headline: '',
        img: 'http://igstech.com.cn/resources/shouye/sifangge/sifasifangge1.jpg',
      },
      {
        text: '',
        slogan: 'IGS 25',
        headline: '',
        img: 'http://igstech.com.cn/resources/shouye/sifangge/sifasifangge2.jpg',
      },
      {
        text: '',
        slogan: 'IGS 60',
        headline: '',
        img: 'http://igstech.com.cn/resources/shouye/sifangge/sifasifangge3.jpg',
      },
      {
        text: '',
        slogan: 'IGS',
        headline: 'Family',
        img: 'http://igstech.com.cn/resources/shouye/sifangge/sifasifangge4.jpg',
      },
    ]
	},
	// 创新故事
	getInnovationStory: ()=> {
		return {
      text: 'Immersive planting experience',
      desc: 'Plantable at any time, enjoying the fun of planting at home, efficient planting, and short crop growth cycle.',
      list: [
        {
          // text: '一起来守护文化遗产', headline: '2021年文化遗产数字化 <br/> 贴近摄影测量大赛',
          img: 'http://igstech.com.cn/resources/shouye/tupianzhanshi/tupianzhanshi-2.jpg',
        },
        {
          // text: '科技启迪生长', headline: '助力万顷农田增产创收 <br/> 帮扶农村青年创业就业',
          img: 'http://igstech.com.cn/resources/shouye/tupianzhanshi/tupianzhanshi-1.jpg',
        },
      ],
    }
	},
	// 附属产品介绍
	getChilModule: ()=> {
		return {
      text: 'There are more styles waiting for you to choose from!',
      list: [
        {
          //   slogan: '专业影像',
          //   headline: '天地一体的专业拍摄解决方案',
          img: 'http://igstech.com.cn/resources/shouye/bat2/1.jpeg',
        },
        {
          //   slogan: '行业应用',
          //   headline: '智能化行业解决方案',
          img: 'http://igstech.com.cn/resources/shouye/bat2/2.jpeg',
        },
        {
          //   slogan: '农业植保',
          //   headline: '智慧农业解决方案',
          img: 'http://igstech.com.cn/resources/shouye/bat2/3.jpeg',
        },
      ],
    }
	},
}